import { gql } from '@apollo/client'
import { BOUNDING_BOXES_FRAGMENT } from './BoundingBoxesFragment'
import { SIMPLE_PRODUCT_FRAGMENT } from './SimpleProductFragment'

export const SCAN_IMAGE_FRAGMENT = gql`
  fragment ScanImage on ScanImage {
    id
    url
    boundingBoxSet {
      ...BoundingBoxes
    }
    productUpcs
    flagged {
      level
      reason
      reasonType
      moreInfo
      flaggedBy {
        email
      }
      levelRaisedBy {
        email
        firstName
        lastName
      }
      date
    }
    protectedBoxes {
      id
    }
  }
  ${BOUNDING_BOXES_FRAGMENT}
  ${SIMPLE_PRODUCT_FRAGMENT}
`
